import { Nameable, Optionable, SharedOption } from 'types';

import { RegionRange } from 'app/components/regionRangeSelector/types';

export function safeJSONParse(value: string | null) {
  try {
    return JSON.parse(value ?? 'null');
  } catch {
    return null;
  }
}

export function sortByName(a: Nameable, b: Nameable) {
  const nameA: string = a?.name ?? '';
  const nameB: string = b?.name ?? '';
  if (nameA.toLocaleLowerCase() < nameB.toLocaleLowerCase()) {
    return -1;
  }
  if (nameB.toLocaleLowerCase() < nameA.toLocaleLowerCase()) {
    return 1;
  }
  return 0;
}

export const compileOption = (element: Optionable): SharedOption => ({
  text: element.name,
  label: element.name,
  value: element._id.toString(),
});

export const matchRegions = (zipCode: string, range: RegionRange): boolean => {
  const match = zipCode.match(/^\d{4}/g);
  if (!match) {
    console.error('Incorrect zip code:', zipCode);
    return false;
  }
  const code = Number.parseInt(match[0]);
  const [min_a, max_a] = range;

  return min_a <= code && code <= max_a;
};

export const parseBool = (val: string | null): boolean | null => {
  if (val === 'true') return true;
  if (val === 'false') return false;
  return null;
};

export const stringifyBool = (val: boolean | null | undefined): string | null => {
  if (val === true) return 'true';
  if (val === false) return 'false';
  return null;
};

export const stripPhoneNumberPrefix = (phoneNumber: string | null | undefined): string => {
  return phoneNumber ? phoneNumber.replace(/^\+/, '') : '';
};

export function getAddressString(
  street: string | null | undefined,
  roomNumber: string | null | undefined,
  houseNumber: number | string | null | undefined,
  houseNumberExtension: string | null | undefined,
  zipcode: string | null | undefined,
  city: string | null | undefined,
) {
  return `${street}${houseNumber ? ` ${houseNumber}` : ''}${roomNumber ? ` ${roomNumber}` : ''}${houseNumberExtension ? `-${houseNumberExtension}` : ''}, ${zipcode} ${city?.toUpperCase()}`.trim();
}
